<template lang="html">

  <VqModal
    :name="modalName">
    <template v-slot:header>
      <h2 class="modal-title">{{ $t('components.modalLogin.title') }}</h2>
    </template>
    <template v-slot:content>
      <div class="forms card">
        <form>
          <div class="container has-separator">  
            <div v-if=isLogin>
              <div
                v-if="errors.non_field_errors.length"
                class="form-control is-error">
                <p
                  v-for="(error, index) in errors.non_field_errors"
                  :key="index"
                  class="form-label is-error is-center-aligned">{{ error }}</p>
              </div>
              <div class="row">
                <VqInput
                  :label="$t('components.modalLogin.form.username')"
                  classes="col-tab-12"
                  name="username"
                  type="text"
                  :errors="errors.username"
                  v-model="formData.username"
                  @keyup.enter.native="submit"
                />
              </div>
              <div class="row">
                <VqInput
                  :label="$t('components.modalLogin.form.password')"
                  classes="col-tab-12"
                  name="password"
                  type="password"
                  :errors="errors.password"
                  v-model="formData.password"
                  @keyup.enter.native="submit"
                />
              </div>
            </div>

            <div v-else class="forms">
              <VqInput
                :label="$t('views.login.form.code')"
                name="code"
                type="text"
                :errors="codeError.code"
                v-model="code"
              />
              <p class="pointer form-control is-right-aligned" @click="sendMfa()">{{ $t('views.login.form.send_again') }}</p>
            </div>
          </div>
        </form>
      </div>
    </template>
    <template v-slot:footer>
      <div>
        <button
          :class="{'is-loading': isFormLoading}"
          type="button"
          class="button is-small is-gamma"
          @click="submit">
          {{ $t('components.modalLogin.form.cta') }}
        </button>
      </div>
    </template>
  </VqModal>

</template>

<script lang="js">
import { eventHubMixin } from '@/mixins/event';

import PROBLEMS from '@/api/problems';
import SUPPORT from '@/api/support';
import DIRECTOR from '@/api/director';
import AUTH from '@/api/auth';

import VqModal from '@/components/VqModal.vue';
import VqInput from '@/components/VqInput.vue';


export default {
  name: 'ModalLogin',
  mixins: [eventHubMixin],
  components: {
    VqModal,
    VqInput,
  },
  props: [],

  data() {
    return {
      modalName: 'login',
      formData: {},
      errors: {},
      isFormLoading: false,
      code: "",
      codeError: "",
      isLogin: true
    };
  },
  created() {
    this.initFormErrors();
    this.initFormData();
  },
  mounted() {
    this.onOpenModal(this.modalName, () => {
      this.initFormData();
      this.initFormErrors();
    });
  },
  methods: {
    close() {
      this.emitCloseModal(this.modalName);
    },

    initFormData() {
      this.formData = {
        username: '',
        password: '',
      };
    },

    initFormErrors() {
      this.errors = {
        username: [],
        password: [],
        non_field_errors: [],
      };
    },

    submit() {
      if (this.isLogin) {
        this.login()
      } else {
        this.checkMfa()
      }
    },

    login() {
      this.isFormLoading = true;
      this.initFormErrors();
      this.$store.dispatch('auth/login', this.formData).then(() => {
        this.isFormLoading = false;
        SUPPORT.login(this.formData);
        PROBLEMS.login(this.formData);
        DIRECTOR.login(this.formData);
        this.isLogin = false
        // this.$router.go();
      }, (err) => {
        this.isFormLoading = false;
        Object.assign(this.errors, err.response.data);
      });
    },

    sendMfa() {
      AUTH.sendMfa().then(() => {
        this.emitAddToaster({
          title: this.$t('views.login.form.code_sent'),
          text: this.$t('views.login.form.code_sent_detail'),
          state: 'success',
        })
      })
    },

    checkMfa() {
      AUTH.checkMfa({code: this.code}).then(() => {
        // this.$router.replace({ name: 'dashboard', params: { locale: this.$i18n.locale } });
        this.$router.go();

      }, (err) => {
        this.codeError = err.response.data;
      });
    },
  },
};
</script>
